import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueScroller from 'vue-scroller';
import './plugins/vant';
import './common/js/filters';
import './components/global-reference'; //全局引用的组件
import * as vClickOutside from 'v-click-outside-x';
Vue.config.productionTip = false;
Vue.use(VueScroller);
Vue.use(vClickOutside);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');